import { baseApi } from "@/shared/api";
import type { SelfServiceProfile } from "../../shared/types";

export const profileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSelfProfile: builder.query<SelfServiceProfile, void>({
      query: () => ({
        url: "/api/self/profile/",
        method: "GET",
        credentials: "include",
      }),
      providesTags: [{ type: "SelfService" as const, id: "PROFILE" }],
    }),
  }),
});

export const { useGetSelfProfileQuery } = profileApi;

